const SYMBOLS = {
  AUD: "$", USD: "$", CAD: "$", NZD: "$", SGD: "$",
  GBP: "£", EUR: "€", CHF: "CHF ", JPY: "¥",
};

export function currencySymbol(code) {
  return SYMBOLS[code] || "$";
}

export function formatMoney(amount, currency = "AUD") {
  const n = Number(amount || 0);
  const sym = currencySymbol(currency);
  const decimals = currency === "JPY" ? 0 : 0;
  const formatted = n.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${sym}${formatted}`;
}

export function toDateStr(date) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function dateToIso(dateStr) {
  if (!dateStr) return null;
  return new Date(`${dateStr}T12:00:00`).toISOString();
}

export function formatDate(iso, opts) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, opts || { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}
